<div class="page-layout carded left-sidenav">

  <div *ngIf="isShowBreadcrumbs" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" [iconClass]="'fas fa-briefcase'"></particle-breadcrumbs>
    </div>
  </div>

  <div *ngIf="isShowActionItems" class="toolbar second-level-toolbar p-l-18 flex flex-col justify-start items-center">
    <!--fxHide fxShow.gt-sm-->
    <div class="m-r-20 flex flex-row justify-start items-center">
      <button mat-icon-button class="treaty-button"
              fuseMatSidenavToggler="carded-left-sidenav"
              particleAnalytics
              analyticsCategory="document-viewer"
              analyticsAction="sidenav-btn">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="toolbar-separator h-n-18"></div>
    </div>
    <div class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis">
      <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
        <label class="component-label"> Actions</label>
        <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

          <div class="button-container flex flex-row justify-start items-center">
            <button mat-button class="orbitax-flat-button"
                    (click)="downloadPDF()"
                    particleAnalytics
                    analyticsCategory=""
                    analyticsAction=""> Download (PDF)
            </button>

            <div class="toolbar-separator"></div>
          </div>

          <div class="button-container flex flex-row justify-start items-center">
            <button mat-button class="orbitax-flat-button"
                    printSectionId="treatyDocument"
                    ngxPrint
                    particleAnalytics
                    analyticsCategory=""
                    analyticsAction=""> Print Page
            </button>

            <div class="toolbar-separator"></div>
          </div>

        </div>
      </div>

      <div *ngIf="otherVersions && otherVersions.length > 0"
           class="other-version-parent flex flex-row justify-end items-center">
        <div class="other-version grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
          <button mat-button class="submit-changes" (click)="otherVersionDisplay()">
            <i class="fas fa-database"></i>
            Other versions
            <i class="fas fa-caret-down"></i>
          </button>

          <div class="popover-container" *ngIf="otherVersionsContentViewEnable">
            <div class="flex flex-col">
              <div class="header flex flex-row justify-between items-center">
                <h1>Other Versions</h1>
                <a (click)="otherVersionDisplay()"><i class="far fa-times-circle"></i></a>
              </div>
              <ul>
                <li *ngFor="let file of otherVersions" [ngClass]="{'active': file.isActive===true}">
                  <a (click)="showPdf(file)">
                    <span *ngIf="file.title">{{file.title}}</span>
                    <span *ngIf="file.language"> - {{file.language}}</span>
                    <span *ngIf="file.format"> - {{file.format}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <mat-sidenav-container>
    <mat-sidenav class="sidenav content-navigation" position="start" opened="true" mode="side"
                 fuseMatSidenavHelper="carded-left-sidenav" mat-is-locked-open="gt-md"
    >

      <mat-tab-group class="treaty-slidebar">
        <mat-tab label="Documents" *ngIf="sidebarInfo || isShowOtherDocumentOnly">
          <mat-list class="table-of-content-wrapper w-p-100 flex flex-col">
            <particle-treaty-document-sidebar [isShowOtherDocumentOnly]=isShowOtherDocumentOnly
                                              [info]="sidebarInfo"
                                              [projectId]="currentProjectId"
                                              [refresh]="refresh.asObservable()"
                                              (documentIdChanged)="onDocumentChanged($event)"></particle-treaty-document-sidebar>
          </mat-list>
        </mat-tab>
        <mat-tab label="Table of Contents"
                 *ngIf="treatyDocumentContent && treatyDocumentContent.articles.length > 0">
          <mat-list class="table-of-content-wrapper w-p-100 flex flex-col">
            <ng-container *ngIf="treatyDocumentContent">
              <mat-list-item *ngFor="let article of treatyDocumentContent.articles" class="auto-flex">
                <div class="w-p-100 full-grow-no-shrink-no-basis">
                  <div
                    class="table-of-content-container w-p-100 flex flex-col justify-center items-start full-grow-no-shrink-no-basis">
                    <div class="title auto-flex" [ngClass]="{'active': article.isActive===true}">
                      <a [routerLink]='"."' [fragment]="article.articleTag">
                        <particle-dynamic-html
                          [content]="article.articleMenu"></particle-dynamic-html>
                      </a>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>

          </mat-list>
        </mat-tab>
      </mat-tab-group>
    </mat-sidenav>

    <div class="center" id="top">
      <!-- CONTENT CARD -->
      <button id="document-ngx-print"
              printSectionId="treatyDocument"
              ngxPrint
              style="display: none"
      >
      </button>
      <div class="content-card mat-white-bg"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType == 'PDF'">
        <!-- CONTENT -->
        <div class="content" style="display: block">
          <particle-treaty-pdf-viewer [fileInfo]="fileInfo"></particle-treaty-pdf-viewer>
        </div>
        <!-- / CONTENT -->
      </div>

      <div class="content-card" *ngIf="treatyDocumentContent && !treatyDocumentContent.contentType"
           id="treatyDocument">
        <div class="content">
          <div class="treaty-container">
            <div *ngIf="treatyDocumentContent && treatyDocumentContent.relationTreaty"
                 class="document-heading">
              <particle-dynamic-html
                [content]="treatyDocumentContent.relationTreaty"></particle-dynamic-html>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent.heading" class="document-heading">
              <particle-dynamic-html [content]="treatyDocumentContent.heading"></particle-dynamic-html>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent.createArticle"
                 class="create-article">
              <particle-dynamic-html
                [content]="treatyDocumentContent.createArticle"></particle-dynamic-html>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent.content" class="document-content">
              <particle-dynamic-html [content]="treatyDocumentContent.content"></particle-dynamic-html>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent?.terminatedNote"
                 class="suspended-note">
              <i class="fa-solid fa-triangle-exclamation"></i>
              <particle-dynamic-html
                [content]="treatyDocumentContent.terminatedNote"></particle-dynamic-html>
            </div>
            <div
              *ngIf="treatyDocumentContent && !treatyDocumentContent?.terminatedNote && treatyDocumentContent?.suspendedNote"
              class="suspended-note">
              <i class="fa-solid fa-triangle-exclamation"></i>
              <particle-dynamic-html
                [content]="treatyDocumentContent.suspendedNote"></particle-dynamic-html>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent.note && treatyDocumentContent.note.length > 0"
                 class="document-note">
              <i class="fa-solid fa-circle-info"></i>
              <particle-dynamic-html [content]="treatyDocumentContent.note"></particle-dynamic-html>
            </div>

            <div
              *ngIf="treatyDocumentContent && treatyDocumentContent.mliNotes && treatyDocumentContent.mliNotes.length > 0"
              class="mli-note">
              <i class="fa-solid fa-circle-exclamation"></i>
              <div>
                <div class="flex flex-col justify-start items-start">
                  <div style="display: inline">
                    <strong>Note : </strong>
                    <particle-dynamic-html-anchor [content]="treatyDocumentContent.mliNotes"
                                                  (event)="showArticle($event)"></particle-dynamic-html-anchor>
                  </div>
                  <mat-list *ngIf="treatyDocumentContent.mliPositionInfo" class="mli-position">
                    <mat-list-item
                      *ngIf="treatyDocumentContent.mliPositionInfo.country1MliPositionLink">
                      <mat-icon matListIcon>info</mat-icon>
                      <a target="_blank"
                         [href]="treatyDocumentContent.mliPositionInfo.country1MliPositionLink"
                         class="ng-binding"> {{treatyDocumentContent.mliPositionInfo.country1MliPositionDisplayName}}</a>
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </mat-list-item>

                    <mat-list-item
                      *ngIf="treatyDocumentContent.mliPositionInfo.country2MliPositionLink">
                      <mat-icon matListIcon>info</mat-icon>
                      <a target="_blank"
                         [href]="treatyDocumentContent.mliPositionInfo.country2MliPositionLink"
                         class="ng-binding"> {{treatyDocumentContent.mliPositionInfo.country2MliPositionDisplayName}}</a>
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </mat-list-item>
                  </mat-list>
                  <div class="mli-entry"><b>MLI entry into force
                    :</b> {{treatyDocumentContent.mliEntryIntoForceDate}}
                  </div>
                  <div *ngIf="treatyDocumentContent.mliEntryIntoForceDate !== 'Not yet in force'"
                       class="mli-effective-date">
                    <!-- <b>MLI Effective date(s):</b> -->
                    <div *ngFor="let item of treatyDocumentContent.mliEffectiveDateDetails"
                         class="item">
                      <span> <b>{{item.title}} :</b> </span> {{item.details}}
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="treatyDocumentContent && treatyDocumentContent.preambleNotes && treatyDocumentContent.preambleNotes.length > 0"
              class="preamble-note flex flex-col justify-start items-start" id="preamble">
              <div *ngFor="let preamble of treatyDocumentContent.preambleNotes">
                <div class="preamble-note-container">
                  <i class="fa-solid fa-circle-exclamation"></i>

                  <particle-dynamic-html-anchor [content]="preamble"
                                                (event)="showArticle($event)"></particle-dynamic-html-anchor>
                </div>
              </div>
            </div>

            <div *ngIf="treatyDocumentContent && treatyDocumentContent.headingInfo" class="heading-info">
              <particle-dynamic-html
                [content]="treatyDocumentContent.headingInfo"></particle-dynamic-html>
            </div>

            <div
              *ngIf="treatyDocumentContent && treatyDocumentContent.headingConclusion && treatyDocumentContent.headingConclusion.length > 0"
              class="preamble-note flex flex-col justify-start items-start">
              <div *ngFor="let item of treatyDocumentContent.headingConclusion" class="individual">
                <div class="preamble-note-container">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  <particle-dynamic-html [content]="item"></particle-dynamic-html>
                </div>
              </div>
            </div>

            <div *ngIf="treatyDocumentContent &&  treatyDocumentContent.articles">
              <div *ngFor="let article of treatyDocumentContent.articles"
                   class="chapter-content-container">
                <div class="flex flex-col">
                  <div class="heading" id="{{article.articleTag}}">
                    <particle-dynamic-html [content]="article.articleNo"></particle-dynamic-html>
                    <particle-dynamic-html [content]="article.articleTitle"></particle-dynamic-html>

                    <div *ngIf="article.mliSummary && article.mliSummary.length > 0"
                         class="mli-notes flex flex-col justify-start items-start">
                      <div *ngFor="let summary of article.mliSummary" class="individual">
                        <div class="mli-notes-container">
                          <i class="fa-solid fa-circle-exclamation"></i>
                          <particle-dynamic-html-anchor [content]="summary" class="dynamic"
                                                        (event)="showArticle($event)"></particle-dynamic-html-anchor>
                        </div>
                      </div>
                    </div>

                  </div>
                  <particle-dynamic-html class="article-content"
                                         [content]="article.content"></particle-dynamic-html>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="content-card" *ngIf="treatyDocumentContent && treatyDocumentContent.contentType == 'Dynamic'">
        <div class="content">
          <particle-treaty-status [countryCode1]="country1" [countryCode2]="country2" [info]="dynamicInfo"
                                  [type]="treatyDocumentContent.contentType"></particle-treaty-status>
        </div>

      </div>

      <div class="particle-treaty-news-container"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType =='TreatyNews'">
        <particle-treaty-news [info]="dynamicInfo"></particle-treaty-news>
      </div>

      <div class="particle-treaty-news-container"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType =='TreatySummary'">
        <particle-treaty-summary [info]="dynamicInfo"></particle-treaty-summary>
      </div>


      <div class="particle-treaty-news-container flex flex-row full-grow-no-shrink-no-basis"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType =='WithholdingTaxRates'">
        <particle-withholding-tax-rates [countryCode1]="country1" [countryCode2]="country2"
                                        [info]="dynamicInfo"></particle-withholding-tax-rates>
      </div>

      <div class="particle-treaty-news-container"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType =='WithholdingTaxForms'">
        <particle-withholding-tax-forms [countryCode1]="country1" [countryCode2]="country2"
                                        [info]="dynamicInfo"></particle-withholding-tax-forms>
      </div>

      <div class="particle-treaty-news-container"
           *ngIf="treatyDocumentContent && treatyDocumentContent.contentType =='BEPSCbCExchangeStatus'">
        <particle-treaty-status [countryCode1]="country1" [countryCode2]="country2" [info]="dynamicInfo"
                                [type]="treatyDocumentContent.contentType"></particle-treaty-status>
      </div>


      <!-- / CONTENT CARD -->
    </div>
  </mat-sidenav-container>
</div>




